import { IDeliveryInfo } from "../../interfaces";
import vendors from "../vendors";
import { VENDOR_PROCESS_FUNCTIONS } from "../vendors/vendorProcessEnumerations";

const cleanCart = async (
  vendorId: string,
  userId: string,
  body: {
    deliveryInfo: IDeliveryInfo;
  }
) => {
  return await vendors.runVendorProcess(
    VENDOR_PROCESS_FUNCTIONS.CLEAN_CART,
    vendorId,
    userId,
    body
  );
};

export default cleanCart;
